import React, { useState } from "react";

const PopupContext = React.createContext();

export const PopupProvider = ({ children }) => {
    // ONBOARDING COMPLETED POPUPS
    const [showOnboardingCompletedPopup, setShowOnboardingCompletedPopup] = useState(false);

    // GENERIC CONFIRMATION POPUP -> use this by calling Library.showConfirmationMessage({ ... })
    const [genericConfirmationPopup, setGenericConfirmationPopup] = useState({ show: false });

    return (
        <PopupContext.Provider
            value={{
                showOnboardingCompletedPopup,
                setShowOnboardingCompletedPopup,

                genericConfirmationPopup,
                setGenericConfirmationPopup
            }}>
            {children}
        </PopupContext.Provider>
    );
};

export const resetConfirmationPopup = setGenericConfirmationPopup => {
    setGenericConfirmationPopup({ show: false });
};

export default PopupContext;
